// RocketChart logo — ascending bar chart with a rocket in the center.
// Color is driven by the brand accent (defaults to indigo).
export default function BrandLogo({ color = "#6366F1", size = 32 }) {
  const stroke = color;
  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Ascending bar chart in the background */}
      <rect x="3" y="30" width="6" height="12" rx="1" fill={stroke} opacity="0.25" />
      <rect x="11" y="24" width="6" height="18" rx="1" fill={stroke} opacity="0.4" />
      <rect x="31" y="18" width="6" height="24" rx="1" fill={stroke} opacity="0.4" />
      <rect x="39" y="10" width="6" height="32" rx="1" fill={stroke} opacity="0.55" />

      {/* Rocket body */}
      <g transform="translate(24 24)">
        {/* flame */}
        <path d="M-2.5 8 Q0 14 2.5 8 Q0 11 -2.5 8 Z" fill="#F59E0B" />
        <path d="M-1.5 8 Q0 11 1.5 8 Q0 10 -1.5 8 Z" fill="#F43F5E" />
        {/* rocket silhouette (pointing up-right) */}
        <path
          d="M-4 4 L-1 -8 Q0 -11 1 -8 L4 4 L2 4 L2 7 L-2 7 L-2 4 Z"
          fill={stroke}
          stroke={stroke}
          strokeWidth="1"
          strokeLinejoin="round"
        />
        {/* porthole */}
        <circle cx="0" cy="-3" r="1.6" fill="#0B0F17" />
        {/* fins */}
        <path d="M-4 4 L-5.5 7 L-2 5 Z" fill={stroke} opacity="0.75" />
        <path d="M4 4 L5.5 7 L2 5 Z" fill={stroke} opacity="0.75" />
      </g>
    </svg>
  );
}
